export const getTimeToDate = (time) => {
  let arr = time?.split(':');
  return new Date(new Date().setHours(arr[0], arr[1], '00'));
};
